/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DayModelContentResponse } from './DayModelContentResponse';
import {
    DayModelContentResponseFromJSON,
    DayModelContentResponseFromJSONTyped,
    DayModelContentResponseToJSON,
    DayModelContentResponseToJSONTyped,
} from './DayModelContentResponse';

/**
 * Response for day model
 * @export
 * @interface DayModelResponse
 */
export interface DayModelResponse {
    /**
     * Unique identifier of the day model
     * @type {string}
     * @memberof DayModelResponse
     */
    dayModelId?: string;
    /**
     * Unique identifier of the appointmentType
     * @type {string}
     * @memberof DayModelResponse
     */
    appointmentTypeId?: string;
    /**
     * Name of day model
     * @type {string}
     * @memberof DayModelResponse
     */
    name?: string;
    /**
     * Indicate if the settings is a quick param
     * @type {boolean}
     * @memberof DayModelResponse
     */
    quickParam?: boolean;
    /**
     * list of dayModel data
     * @type {Array<DayModelContentResponse>}
     * @memberof DayModelResponse
     */
    dayModelContent?: Array<DayModelContentResponse>;
}

/**
 * Check if a given object implements the DayModelResponse interface.
 */
export function instanceOfDayModelResponse(value: object): value is DayModelResponse {
    return true;
}

export function DayModelResponseFromJSON(json: any): DayModelResponse {
    return DayModelResponseFromJSONTyped(json, false);
}

export function DayModelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DayModelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'dayModelId': json['dayModelId'] == null ? undefined : json['dayModelId'],
        'appointmentTypeId': json['appointmentTypeId'] == null ? undefined : json['appointmentTypeId'],
        'name': json['name'] == null ? undefined : json['name'],
        'quickParam': json['quickParam'] == null ? undefined : json['quickParam'],
        'dayModelContent': json['dayModelContent'] == null ? undefined : ((json['dayModelContent'] as Array<any>).map(DayModelContentResponseFromJSON)),
    };
}

export function DayModelResponseToJSON(json: any): DayModelResponse {
    return DayModelResponseToJSONTyped(json, false);
}

export function DayModelResponseToJSONTyped(value?: DayModelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dayModelId': value['dayModelId'],
        'appointmentTypeId': value['appointmentTypeId'],
        'name': value['name'],
        'quickParam': value['quickParam'],
        'dayModelContent': value['dayModelContent'] == null ? undefined : ((value['dayModelContent'] as Array<any>).map(DayModelContentResponseToJSON)),
    };
}

